import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRequestContextService } from '../../../app-request-context.service';

export const singleCategoryRedirectGuardFn: CanActivateFn = () => {
  const router = inject(Router);
  const appRequestContext = inject(AppRequestContextService);

  const activeCategories = appRequestContext.activeCategories();

  if (activeCategories.length === 1) {
    router.navigate(['/categoria', activeCategories[0].id], { replaceUrl: true });
    return false;
  }

  return true;
};
